import { useQuery } from "@tanstack/react-query";

import { bffAxios } from "@av/config/api-config/axios-config";

type RumTelemetry = "performance" | "errors" | "http";

type EnabledRumWebClientConfig = {
  enabled: true;
  allowCookies: boolean;
  applicationId: string;
  applicationRegion: string;
  enableXRay: boolean;
  endpoint: string;
  guestRoleArn: string;
  identityPoolId: string;
  sessionSampleRate: number;
  telemetries: RumTelemetry[];
};

type DisabledRumWebClientConfig = { enabled: false };

export type RumWebClientConfig = EnabledRumWebClientConfig | DisabledRumWebClientConfig;

export function useRumConfigQuery() {
  return useQuery({
    queryKey: ["rum-config"],
    queryFn: async function (): Promise<RumWebClientConfig> {
      const { data } = await bffAxios.get<{ rum: RumWebClientConfig }>("/rum");

      return data.rum;
    },
    // RUM config is startup config; do not refetch or retry it from this bootstrap component.
    retry: false,
    staleTime: Infinity,
  });
}
